import { Box, SkeletonCircle } from "@chakra-ui/react";

const AliciaChatbotSkeleton = (): React.JSX.Element =>
  <Box
    data-testid="chatbot-skeleton"
    position='fixed'
    zIndex={2}
    right='5px'
    bottom='5px'
  >
    <SkeletonCircle size="12" />
  </Box>;

export default AliciaChatbotSkeleton;